import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

export const useDeleteJobType = createMutationHook<void, string>({
  mutationFn: (id) => apiDelete(operationsClient, settingsEndpoints.jobType(id)),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.jobTypes() });
    toast.success('Job type deleted');
  },
});
